import React from 'react'

import { useTheme } from 'styled-components/native'

import {
  AIDraftStatus,
  noteSummaryStatusText,
  summaryStatusText,
} from '@lyrahealth-inc/shared-app-logic/src/models/appointmentSummary/AppointmentSummary'

import { BadgeShape, BadgeVariant } from '../../badge/constants'
import { IconBadge } from '../iconBadge/IconBadge'
import { SparklesIcon } from '../icons/SparklesIcon'
import { SparkleSingleIcon } from '../icons/SparkleSingleIcon'

export type AIStatusBadgeProps = {
  customText?: string
  digestType?: DigestType
  hideText?: boolean
  status?: AIDraftStatus
  /** Optional override for badge shape (defaults to round). ProviderPayments should pass RECT. */
  shape?: BadgeShape
}

export enum DigestType {
  DRAFT = 'DRAFT',
  SUMMARY = 'SUMMARY',
}

const ColorableSparklesIcon = ({ fillColor }: { fillColor?: string }) => <SparklesIcon size={16} color={fillColor} />
const ColorableSparkleSingleIcon = ({ fillColor }: { fillColor?: string }) => (
  <SparkleSingleIcon size={16} color={fillColor} />
)

export const AIStatusBadge = ({
  customText,
  digestType = DigestType.DRAFT,
  hideText = false,
  status = AIDraftStatus.COMPLETE,
  shape = BadgeShape.ROUND,
}: AIStatusBadgeProps) => {
  const theme = useTheme()
  const summaryText = digestType === DigestType.DRAFT ? noteSummaryStatusText[status] : summaryStatusText[status]

  const isComplete = status === AIDraftStatus.COMPLETE
  return (
    <IconBadge
      variant={isComplete ? BadgeVariant.INFO_PRIMARY : BadgeVariant.NEUTRAL}
      shape={shape}
      text={hideText ? '' : customText ? customText : summaryText}
      frontIcon={digestType === DigestType.DRAFT ? <ColorableSparklesIcon /> : <ColorableSparkleSingleIcon />}
      preserveCase={false}
      bold={digestType === DigestType.SUMMARY}
      testID={`AIStatusBadge-${status}`}
      gradient={isComplete ? [theme.colors.gradientBoxStart, theme.colors.gradientBoxEnd] : undefined}
    />
  )
}
